import { Timestamp } from 'firebase/firestore';

export type SeekOutcome = 'no_answer' | 'attempt' | 'success' | 'survey';

// A location physically worked in seek-and-find mode. Accumulates into a
// reusable "universe of locations" the team can revisit pass-over-pass and
// year-over-year.
export interface DiscoveredLocation {
  id: string;
  projectId: string;
  location: { lat: number; lng: number };
  outcome: SeekOutcome;
  notes?: string;
  leadId?: string;       // set when a Success routed into a captured lead
  surveyResponseId?: string; // set when a Survey outcome recorded responses
  accuracy?: number;     // GPS accuracy in meters at capture time
  capturedBy: string;
  capturedByName?: string;
  createdAt: Timestamp;
}

export const SEEK_OUTCOMES: { value: SeekOutcome; label: string; color: string }[] = [
  { value: 'no_answer', label: 'No Answer', color: '#D97706' },
  { value: 'attempt', label: 'Contact Attempt', color: '#2563EB' },
  { value: 'survey', label: 'Survey', color: '#7C3AED' },
  { value: 'success', label: 'Success', color: '#059669' },
];

export const seekOutcomeMeta = (o: SeekOutcome) =>
  SEEK_OUTCOMES.find(s => s.value === o) || SEEK_OUTCOMES[0];
